
(function() { 
  console.log("wholesale-switch.js loaded");

  const wholesaleSwitch = document.querySelectorAll('.tiered-discount-block');

  if (wholesaleSwitch.length > 0) { 
    wholesaleSwitch.forEach((switchBlock) => {
      switchBlock.addEventListener('click', function() {
        // Remove the class from all switchBlocks
        wholesaleSwitch.forEach((block) => {
          block.classList.remove('tiered-discount-block--active');
        });
        
        // Add the class to the clicked switchBlock
        this.classList.add('tiered-discount-block--active');

        const priceElement = this.querySelector('.price-element');
        const price = priceElement ? priceElement.getAttribute('data-price') : null;
        const quantity = priceElement ? priceElement.getAttribute('data-quantity') : null;
    
        if (price) {
          console.log('Selected price:', price);
        }

        if (quantity) {
          console.log('Selected quantity:', quantity);
          let quantityInput = document.querySelector('.t4s-quantity-input');
          if (quantityInput) {
            quantityInput.value = quantity;
            quantityInput.dispatchEvent(new Event('change'));
          }
        }
      });
    });
  }
}());